import { BenefitStatus, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Benefit Status`;

export type CPBenefitStatusLocs =
	| 'CPBenefitStatusEnumActive'
	| 'CPBenefitStatusEnumUsed'
	| 'CPBenefitStatusEnumExpired';

export type SPBenefitStatusLocs =
	| 'SPBenefitStatusEnumActive'
	| 'SPBenefitStatusEnumUsed'
	| 'SPBenefitStatusEnumExpired';

export const cpBenefitStatusEnumLocs: LocDefs<CPBenefitStatusLocs> = {
	CPBenefitStatusEnumActive: {
		defaultValue: 'Active',
		displayPath: `${dpRoot}|${BenefitStatus.Active}`,
		description: `System value for '${BenefitStatus.Active}' benefit status`,
		legacyName: 'Credential/System.Enum.BenefitStatus.Active',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		feature: HubFeature.Benefit,
		portal: 'CP',
	},
	CPBenefitStatusEnumUsed: {
		defaultValue: 'Used',
		displayPath: `${dpRoot}|${BenefitStatus.Used}`,
		description: `System value for '${BenefitStatus.Used}' benefit status`,
		legacyName: 'Credential/System.Enum.BenefitStatus.Used',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		feature: HubFeature.Benefit,
		portal: 'CP',
	},
	CPBenefitStatusEnumExpired: {
		defaultValue: 'Expired',
		displayPath: `${dpRoot}|${BenefitStatus.Expired}`,
		description: `System value for '${BenefitStatus.Expired}' benefit status`,
		legacyName: 'Credential/System.Enum.BenefitStatus.Expired',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		feature: HubFeature.Benefit,
		portal: 'CP',
	},
};

export const spBenefitStatusEnumLocs: LocDefs<SPBenefitStatusLocs> = {
	SPBenefitStatusEnumActive: {
		defaultValue: 'Active',
		displayPath: `${dpRoot}|${BenefitStatus.Active}`,
		description: `System value for '${BenefitStatus.Active}' benefit status`,
		legacyName: 'Credential/System.Enum.BenefitStatus.Active',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		feature: HubFeature.Benefit,
		portal: 'SP',
	},
	SPBenefitStatusEnumUsed: {
		defaultValue: 'Used',
		displayPath: `${dpRoot}|${BenefitStatus.Used}`,
		description: `System value for '${BenefitStatus.Used}' benefit status`,
		legacyName: 'Credential/System.Enum.BenefitStatus.Used',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		feature: HubFeature.Benefit,
		portal: 'SP',
	},
	SPBenefitStatusEnumExpired: {
		defaultValue: 'Expired',
		displayPath: `${dpRoot}|${BenefitStatus.Expired}`,
		description: `System value for '${BenefitStatus.Expired}' benefit status`,
		legacyName: 'Credential/System.Enum.BenefitStatus.Expired',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		feature: HubFeature.Benefit,
		portal: 'SP',
	},
};

export const BENEFIT_STATUS_ENUM_LOCS = MapLocKeys<CPBenefitStatusLocs | SPBenefitStatusLocs>({
	...cpBenefitStatusEnumLocs,
	...spBenefitStatusEnumLocs,
});

export type CPBenefitStatusEnumLocType = LocMap<CPBenefitStatusLocs>;
export type SPBenefitStatusEnumLocType = LocMap<SPBenefitStatusLocs>;

export const cpBenefitStatusKeys: { [key in BenefitStatus]: keyof CPBenefitStatusEnumLocType } = {
	Active: BENEFIT_STATUS_ENUM_LOCS.CPBenefitStatusEnumActive,
	Used: BENEFIT_STATUS_ENUM_LOCS.CPBenefitStatusEnumUsed,
	Expired: BENEFIT_STATUS_ENUM_LOCS.CPBenefitStatusEnumExpired,
};

export const spBenefitStatusKeys: { [key in BenefitStatus]: keyof SPBenefitStatusEnumLocType } = {
	Active: BENEFIT_STATUS_ENUM_LOCS.SPBenefitStatusEnumActive,
	Used: BENEFIT_STATUS_ENUM_LOCS.SPBenefitStatusEnumUsed,
	Expired: BENEFIT_STATUS_ENUM_LOCS.SPBenefitStatusEnumExpired,
};
